import { useEffect } from "react";
import { useData, useDispatch } from "./DataContext.js";

import Container from "react-bootstrap/Container";

import TeacherNavbar from "./TeacherNavbar.js";
import TeacherSimList from "./TeacherSimList.js";
import SimMain from "./SimMain.js";

export default function TeacherMain ()
{
    const gData = useData();
    const gDispatch = useDispatch();

    useEffect (() => {
	const rememberMe = JSON.parse(localStorage.getItem("rememberMe"));
	if (rememberMe !== null && rememberMe) gDispatch({ type: "continue" });
    }, [gDispatch]);

    const loaded = gData.teacherID !== null && gData.teacher[gData.teacherID] !== undefined;

    return (
	<>
	    <div className="sticky-top">
		<TeacherNavbar/>
	    </div>
	    <Container>
		{! loaded && (<div className="fs-2 text-uppercase text-center w-100 text-secondary mt-5">Page d'accueil à réaliser</div>)}
		{loaded && (
		    <>
			{(gData.simID === null) && (<TeacherSimList/>)}
			{(gData.simID !== null && gData.sim[gData.simID] !== undefined) && (<SimMain/>)}
		    </>
		)}
	    </Container>
	</>
    );
}
